<companyid-content-wrapper
    classNames="items-center justify-between min-h-[675px] tab:min-h-[530px] w-full desk:px-0 px-5 py-40px mob:flex-col-reverse mob:justify-center mob:items-center">
    <div
        class="w-400px desk:mr-2.5 tab:w-[340px] flex flex-col justify-center mob:w-full mob:items-center relative">
        <companyid-avatar />
        <span class="text-extra-small-medium text-primary-text-color">COMPANY ID </span>

        <h1 class="text-h1-bold tab:text-h2-bold mob:text-h2-bold text-dark" i18n=":@@streamline">
            Streamline,
        </h1>

        <div class="flex text-h1-bold tab:text-h2-bold mob:text-h2-bold" i18n=":@@simplify">
            <div
                class="flex text-secondary-color border border-solid border-gray-2 bg-white box-shadow-5 py-[10px] px-25px rounded-50px gap-5 min-w-max">
                Simplify
                <img
                    [ngSrc]="'code' | asset: 'home/hero-block'"
                    alt="code"
                    width="46"
                    height="46" />
            </div>
            <span class="text-dark self-end">,</span>
        </div>
        <h1
            class="text-h1-bold tab:text-h2-bold mob:text-h2-bold text-dark mob:text-center"
            i18n=":@@succeed">
            Succeed
        </h1>

        <span
            class="text-primary-text-color text-large-regular mt-15px mb-40px"
            i18n=":@@focus-on-what-matters"
            >Focus on what matters most: <br />
            growing your business.
        </span>
        <companyid-get-started class="flex" />
    </div>

    <div class="w-full">
        <img
            [ngSrc]="'screens-desktop' | asset: 'home/hero-block' : 'webp'"
            width="946"
            height="755"
            class="desk:absolute desk:bottom-0"
            alt="screens" />
    </div>
</companyid-content-wrapper>
